import { Component, ElementRef, ViewChild } from '@angular/core';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { PAGE_HEIGHT, PAGE_MARGIN, PAGE_WIDTH } from '@app-driver-management/common/driver-management.constants';

@Component({
  selector: 'app-qr-code-guidelines-pdf',
  templateUrl: './qr-code-guidelines-pdf.component.html',
  styleUrls: ['./qr-code-guidelines-pdf.component.scss'],
})
export class QrCodeGuidelinesPdfComponent {
  @ViewChild('pdfcontent') faqSection!: ElementRef;

  public downloadPDF() {
    const DATA = this.faqSection.nativeElement;

    html2canvas(DATA, { scale: 2 }).then((canvas) => {
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = PAGE_WIDTH; // A4 width in mm
      const pageHeight = PAGE_HEIGHT; // A4 height in mm
      const margin = PAGE_MARGIN;

      const contentWidth = pageWidth;
      const contentHeight = pageHeight - 2 * margin;

      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      const aspectRatio = canvasHeight / canvasWidth;
      const imgHeight = contentWidth * aspectRatio;

      // Fit to page height if content height exceeds the available space
      let finalImgWidth = contentWidth;
      let finalImgHeight = imgHeight;

      if (imgHeight > contentHeight) {
        finalImgHeight = contentHeight;
        finalImgWidth = finalImgHeight / aspectRatio;
      }

      const contentDataURL = canvas.toDataURL('image/png');

      const x = (pageWidth - finalImgWidth) / 2;
      const y = (pageHeight - finalImgHeight) / 2;

      pdf.addImage(contentDataURL, 'PNG', x, y, finalImgWidth, finalImgHeight);
      pdf.save('QRcode-Guidelines.pdf');
    });
  }
}
